import {makeServerRequest, makeServerPost} from './util';

const apiPrefix = "/api/v1/report/config";

export const FETCH_REPORT_CONFIG = "FETCH_REPORT_CONFIG";
export const FETCH_REPORT_CONFIG_SUCCESS = "FETCH_REPORT_CONFIG_SUCCESS";
export const FETCH_REPORT_CONFIG_FAILURE = "FETCH_REPORT_CONFIG_FAILURE";

export const UPDATE_REPORT_CONFIG = "UPDATE_REPORT_CONFIG";
export const UPDATE_REPORT_CONFIG_SUCCESS = "UPDATE_REPORT_CONFIG_SUCCESS";
export const UPDATE_REPORT_CONFIG_FAILURE = "UPDATE_REPORT_CONFIG_FAILURE";

const fetchReportConfigSuccess = (reportConfig) => ({
    type: FETCH_REPORT_CONFIG_SUCCESS,
    payload: reportConfig
});

const fetchReportConfigFailure = (error) => ({
    type: FETCH_REPORT_CONFIG_FAILURE,
    payload: error
});

const updateReportConfigSuccess = (reportConfig) => ({
    type: UPDATE_REPORT_CONFIG_SUCCESS,
    payload: reportConfig
});

const updateReportConfigFailure = (error) => ({
    type: UPDATE_REPORT_CONFIG_FAILURE,
    payload: error
});

export const fetchReportConfig = () => (dispatch) => {
    dispatch({type: FETCH_REPORT_CONFIG});

    return makeServerRequest(`${apiPrefix}`).then(
        response => dispatch(fetchReportConfigSuccess(response.data))
    ).catch(
        error => dispatch(fetchReportConfigFailure(error))
    );
};

export const updateReportConfig = (reportConfig) => (dispatch) => {
    dispatch({type: UPDATE_REPORT_CONFIG});

    return makeServerPost(`${apiPrefix}`, reportConfig).then(
        response => dispatch(updateReportConfigSuccess(response.data))
    ).catch(
        error => dispatch(updateReportConfigFailure(error))
    );
};



// WEBPACK FOOTER //
// ./src/store/actions/report.js